export const DEFAULT_IMAGE_VERSION = "raw";
export const DEFAULT_CONVERTED_VERSION = "raw-png";

export const FILES_NOT_PERSISTED = 'FILES_NOT_PERSISTED';
export const FILES_NOT_PERSISTED_TO_GIVEN_LOCATION = 'FILES_NOT_PERSISTED_TO_GIVEN_LOCATION';
